import React, { useState, useEffect } from "react";
import clsx from "clsx";
import loadable from "@loadable/component";

const ReactSVGIcon = loadable(() => import("@micado-digital/react-svg-icon/ReactSVGIcon"));

const Time = ({ handleTimeClick, items, lang, season, time, weather }) => {
	const [hasMorningItems, setHasMorningItems] = useState(false);
	const [hasMiddayItems, setHasMiddayItems] = useState(false);
	const [hasEveningItems, setHasEveningItems] = useState(false);
	const [hasNightItems, setHasNightItems] = useState(false);

	useEffect(() => {
		setHasMorningItems(false);
		setHasMiddayItems(false);
		setHasEveningItems(false);
		setHasNightItems(false);

		if (items?.length > 0) {
			items.map(item => {
				if (item?.keywords) {
					if (
						item.keywords.some(keyword => keyword.title === "Morgen") &&
						item.keywords.some(keyword => keyword.title === season) &&
						item.keywords.some(keyword => keyword.title === weather)
					) {
						setHasMorningItems(true);
					}
					if (
						item.keywords.some(keyword => keyword.title === "Mittag") &&
						item.keywords.some(keyword => keyword.title === season) &&
						item.keywords.some(keyword => keyword.title === weather)
					) {
						setHasMiddayItems(true);
					}
					if (
						item.keywords.some(keyword => keyword.title === "Abend") &&
						item.keywords.some(keyword => keyword.title === season) &&
						item.keywords.some(keyword => keyword.title === weather)
					) {
						setHasEveningItems(true);
					}
					if (
						item.keywords.some(keyword => keyword.title === "Nacht") &&
						item.keywords.some(keyword => keyword.title === season) &&
						item.keywords.some(keyword => keyword.title === weather)
					) {
						setHasNightItems(true);
					}
				}
				return null;
			});
		}
	}, [items, season, weather]);

	return (
		<div className={clsx("video-player-root__buttons", "video-player-root__buttons--time")}>
			<div
				className={clsx("video-player-root__buttons-button", {
					"video-player-root__buttons-button--selected": time === "Morgen",
					"video-player-root__buttons-button--disabled": !hasMorningItems
				})}
				onClick={event => handleTimeClick(event, "Morgen")}
				title="Morgen"
			>
				<ReactSVGIcon color="initial" src="/img/icons/videos/morning.svg" size={24} />
			</div>
			<div
				className={clsx("video-player-root__buttons-button", {
					"video-player-root__buttons-button--selected": time === "Mittag",
					"video-player-root__buttons-button--disabled": !hasMiddayItems
				})}
				onClick={event => handleTimeClick(event, "Mittag")}
				title="Mittag"
			>
				<ReactSVGIcon color="initial" src="/img/icons/videos/midday.svg" size={24} />
			</div>
			<div
				className={clsx("video-player-root__buttons-button", {
					"video-player-root__buttons-button--selected": time === "Abend",
					"video-player-root__buttons-button--disabled": !hasEveningItems
				})}
				onClick={event => handleTimeClick(event, "Abend")}
				title="Abend"
			>
				<ReactSVGIcon color="initial" src="/img/icons/videos/evening.svg" size={24} />
			</div>
			<div
				className={clsx("video-player-root__buttons-button", {
					"video-player-root__buttons-button--selected": time === "Nacht",
					"video-player-root__buttons-button--disabled": !hasNightItems
				})}
				onClick={event => handleTimeClick(event, "Nacht")}
				title="Nacht"
			>
				<ReactSVGIcon color="initial" src="/img/icons/videos/night.svg" size={24} />
			</div>
			<span className={clsx("video-player-root__buttons-label")}>
				{lang === "de" ? "Tageszeit" : "time of day"}
			</span>
		</div>
	);
};

export default Time;
